// Campaign configuration — single source of truth for campaign dates + display strings
// Labor Day 2026 campaign: all orders in by Sept 1; everything ships by Sept 2
// via UPS 2-Day, arriving by Friday Sept 4 — ahead of Labor Day (Mon, Sept 7).

export const CAMPAIGN = {
  // Last moment an order can be placed (end of day Pacific, Sept 1).
  orderDeadline: new Date('2026-09-01T23:59:59-07:00'),
  orderDeadlineDisplay: 'September 1, 2026',
  // Nationwide ship deadline — all orders ship via UPS 2-Day no later than this date
  // to guarantee delivery before Labor Day weekend.
  shipDate: new Date('2026-09-02T00:00:00-07:00'),
  shipDateDisplay: 'September 2, 2026',
} as const
